// extracted by mini-css-extract-plugin
module.exports = {"intervalSpace":"index_intervalSpace__1jz8y"};